import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/ProcessSetupSheet/FormView/AssociatedProducts'

export default createChildListViewContainer()(Component)
